export function ggT(a, b){
	if(a == 0 || b == 0){
		console.log('Achtung beim ggT.', 'a', a, 'b', b)
		return 1
	}

	let divisor = a < b ? a : b
	let first = divisor == a ? b : a

	let rest = 0

	while( true ){
		rest = first % divisor
		first = divisor
		divisor = rest
		if( rest == 0) return first
	}
}

export function kgV(a, b){
	if(a == 0 || b == 0){
		console.log('Achtung beim kgV.', 'a', a, 'b', b)
		return 0
	}

	for(let i = a; i < 10000; i++){
		if(i%a == 0 && i%b == 0){
			return i
		}
	}
}

export function kgV_wert(a, b){
	if(a == 0 || b == 0){
		console.log('Achtung beim kgV.', 'a', a, 'b', b)
		return 0
	}

	for(let i = a; i < 10000; i++){
		if(i%a == 0 && i%b == 0){
			return i/a
		}
	}
}

export function b($oben, $unten, $was) {
	//bekommt zähler und nenner eines bruches, k�rzt diesen und gibt dann je nach $was entweder den nenner oder den z�hler aus
	//sollten beide minus sein, dann minuse wegmachen. sollte nur einer minus haben, dann den z�hler als negativ zur�ck geben
	let $return = 0;

	if ($was == 0) {
		$return = $oben / ggT($oben, $unten);
	} else if ($was == 1) {
		$return = $unten / ggT($oben, $unten);
	} else {
		$return = -1337;
	}


	if ($oben < 0 && $unten < 0) {
		$return = (-1) * $return;
	} else if ($oben < 0 && $unten > 0) {
		//chill
	} else if ($oben > 0 && $unten < 0) {
		$return = (-1) * $return;
	}

	return $return;
}

export function bin($n, $k) {
	//binomialkoeffizienten
	return fac($n, 1) / (fac($k, 1) * fac($n - $k, 1));
}

export function bv($n, $p, $k) {
	//binomialverteilung
	return bin($n, $k) * Math.pow($p, $k) * Math.pow(1 - $p, $n - $k);
}

export function kbv($n, $p, $k) {
	//kumulierte binomialverteilung
	let $ergebnis = 0;

	for (let $i = $k; $i >= 0; $i--) {
		$ergebnis = $ergebnis + bv($n, $p, $i);
	}

	return $ergebnis;
}

export function fac($n, $end) {
	//$n ist die Zahl
	//$end ist bis wohin die fac berechnet werden soll

	if ($n < $end) {
		if ($n == 0 && $end == 1) {
			return 1;
		} else {
			return -1;
		}
	} else if ($n == $end) {
		return $n;
	} else {
		return $n * fac($n - 1, $end);
	}
}


// WEBPACK FOOTER //
// ./src/helper.math.js